/**
 * ページトップ 出る出ないの調整
 */
const toggle = () => {
    const pageTop = document.querySelector('.c-contact');
    const className = 'show';

    if (!pageTop) return false;

    const mTop = window.innerHeight - 100;
    
    if (mTop < window.pageYOffset && !pageTop.classList.contains(className)) {
        pageTop.classList.add(className);
    } else if (mTop >= window.pageYOffset && pageTop.classList.contains(className)) {
        pageTop.classList.remove(className);
    }
};

window.addEventListener('DOMContentLoaded', toggle, false);
window.addEventListener('scroll', toggle, false);


// WEBPACK FOOTER //
// ./js/modules/contact_button.js